// Level test questions (20 items, ~4 per CEFR level A1→C2).
// Difficulty is graduated: q1-3=A1, q4-7=A2, q8-11=B1, q12-15=B2, q16-18=C1, q19-20=C2.
export const LEVEL_TEST_QUESTIONS = [
  // ---- A1 ----
  {
    id: 'q1', level: 'A1',
    prompt: 'Hola, ___ Cecilia. ¿Cómo te llamas?',
    options: ['soy', 'eres', 'es'], correct: 0,
  },
  {
    id: 'q2', level: 'A1',
    prompt: '¿A qué hora ___ (tú) al trabajo por la mañana?',
    options: ['vas', 'voy', 'va'], correct: 0,
  },
  {
    id: 'q3', level: 'A1',
    prompt: 'Yo ___ 30 años.',
    options: ['soy', 'tengo', 'estoy'], correct: 1,
  },
  // ---- A2 ----
  {
    id: 'q4', level: 'A2',
    prompt: 'Ayer no ___ al cine porque estaba cansada.',
    options: ['voy', 'fui', 'iré'], correct: 1,
  },
  {
    id: 'q5', level: 'A2',
    prompt: 'De niña, siempre ___ los sábados a casa de mi abuela.',
    options: ['fui', 'iba', 'he ido'], correct: 1,
  },
  {
    id: 'q6', level: 'A2',
    prompt: 'Esta mañana ___ un café con leche en la cafetería.',
    options: ['he tomado', 'tomé', 'tomaba'], correct: 0,
  },
  {
    id: 'q7', level: 'A2',
    prompt: '¿Qué ___ hoy? Hace mucho frío.',
    options: ['llevas puesto', 'llevabas puesto', 'pondrás'], correct: 0,
  },
  // ---- B1 ----
  {
    id: 'q8', level: 'B1',
    prompt: 'Me gustaría que tú ___ conmigo a la fiesta.',
    options: ['vienes', 'vengas', 'vendrás'], correct: 1,
  },
  {
    id: 'q9', level: 'B1',
    prompt: 'Cuando ___ a España, visitarás muchos monumentos.',
    options: ['vas', 'vayas', 'irás'], correct: 1,
  },
  {
    id: 'q10', level: 'B1',
    prompt: 'No creo que él ___ razón en este tema.',
    options: ['tiene', 'tenga', 'tendrá'], correct: 1,
  },
  {
    id: 'q11', level: 'B1',
    prompt: 'El libro ___ te presté era muy interesante.',
    options: ['que', 'quien', 'lo cual'], correct: 0,
  },
  // ---- B2 ----
  {
    id: 'q12', level: 'B2',
    prompt: 'Si ___ más tiempo libre, viajaría por todo el mundo.',
    options: ['tengo', 'tuviera', 'tendré'], correct: 1,
  },
  {
    id: 'q13', level: 'B2',
    prompt: 'Me dijo que ___ estudiando en Madrid desde hacía años.',
    options: ['estuvo', 'estaba', 'ha estado'], correct: 1,
  },
  {
    id: 'q14', level: 'B2',
    prompt: 'Si me lo hubieras dicho antes, yo te ___ ayudado.',
    options: ['habría', 'había', 'hubiera'], correct: 0,
  },
  {
    id: 'q15', level: 'B2',
    prompt: 'Aunque ___ mucho, no aprobó el examen.',
    options: ['estudió', 'estudiara', 'estudia'], correct: 0,
  },
  // ---- C1 ----
  {
    id: 'q16', level: 'C1',
    prompt: 'La expresión "estar en las nubes" significa:',
    options: [
      'estar volando en un avión',
      'estar distraído o soñando despierto',
      'que hay mucha niebla',
    ],
    correct: 1,
  },
  {
    id: 'q17', level: 'C1',
    prompt: 'Elige la frase con el subjuntivo perfecto correcto:',
    options: [
      'Espero que hayas llegado bien.',
      'Espero que has llegado bien.',
      'Espero que llegarás bien.',
    ],
    correct: 0,
  },
  {
    id: 'q18', level: 'C1',
    prompt: 'Elige el conector adecuado: "Estudió mucho; ___, no aprobó."',
    options: ['por consiguiente', 'sin embargo', 'debido a ello'], correct: 1,
  },
  // ---- C2 ----
  {
    id: 'q19', level: 'C2',
    prompt: '"Tomar el pelo a alguien" significa:',
    options: [
      'peinarle amablemente',
      'engañarle en broma o burlarse',
      'preguntarle su opinión',
    ],
    correct: 1,
  },
  {
    id: 'q20', level: 'C2',
    prompt: 'Elige la opción con matiz más preciso: "Fue un gesto ___ que sorprendió a todos."',
    options: ['osado', 'atrevido', 'temerario'], correct: 2,
  },
];

// Map total correct answers (out of 20) to a suggested CEFR level + landing.
export function computeLevelResult(correctCount) {
  if (correctCount <= 2)  return { level: 'A1', slug: 'espanol-a1',    label: 'Principiante (A1)' };
  if (correctCount <= 6)  return { level: 'A2', slug: 'espanol-a2',    label: 'Elemental (A2)' };
  if (correctCount <= 10) return { level: 'B1', slug: 'espanol-b1',    label: 'Intermedio (B1)' };
  if (correctCount <= 14) return { level: 'B2', slug: 'espanol-b2',    label: 'Intermedio alto (B2)' };
  if (correctCount <= 17) return { level: 'C1', slug: 'espanol-c1-c2', label: 'Avanzado (C1)' };
  return                        { level: 'C2', slug: 'espanol-c1-c2', label: 'Dominio (C2)' };
}
